import React, {Component, ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import {IncubatorUserBetInterface} from 'app/interfaces/IncubatorUserBetInterface';
import {CurrentTimeStore} from 'stores/current_time_store';
import {betMoney, betMoneyCurrency, fixed2, fixed3, isDesktop} from 'app/utils';
import {GAMER_1, GAMER_2} from 'app/utils/Consts';
import Post from 'app/utils/Post';
import BetSlipController from 'app/components/bet_slip/BetSlipController';
import I18n from 'app/i18n';
import {toastInfo} from 'app/components/toasts/liteToast';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    bet: IncubatorUserBetInterface
    currentTimeStore?: CurrentTimeStore
    positionTable: number,
    controller?: BetSlipController
}

@inject('currentTimeStore', 'controller')
@observer
export default class IncubatorUserBet extends Component<Props> {
    timeBeforeAccepting(): string {
        const {currentTimeStore, bet} = this.props;
        const {will_be_accepted_at} = bet;
        const timer = will_be_accepted_at - currentTimeStore.t;

        if (timer < 0) {
            return null;
        }

        return timer.toString();
    }

    suggestionCancel = (): void => {
        this.postAction('/incubator/lines/suggestion_cancel');
    };

    suggestionAccept = (): void => {
        this.postAction('/incubator/lines/suggestion_accept');
    };

    postAction = (url: string): void => {
        const {id} = this.props.bet;

        new Post({params: {id}, url}).execute().then(
            // @ts-ignore
            () => this.props.controller.bets.loadCollection()
        );
    };

    renderAcceptCancelButtons = (not_accept: boolean):ReactNode => <div className="incubator-line-table-buttons">
        <button
            type="button"
            onClick={not_accept ? null : this.suggestionAccept}
            className="incubator-line-table-button incubator-line-table-button--accept"
        >
            <SpriteIcon name="#svg-check" className="svg-default" size={{height: 18, width: 18}}/>
        </button>
        <button
            type="button"
            onClick={not_accept ? null : this.suggestionCancel}
            className="incubator-line-table-button incubator-line-table-button--cancel"
        >
            <SpriteIcon name="#svg-bet-slip-controller-close" className="svg-default" size={{height: 18, width: 18}}/>
        </button>
    </div>;

    onClick = (): void => {
        if (this.props.bet.not_accept) {
            toastInfo(I18n.t('suggestion_pledge'));
        }
    };

    render(): ReactNode {
        const {bet, positionTable} = this.props;

        return <>
            {isDesktop()
                ? <tr
                    className={`${bet.not_accept ? 'disable' : ''}`}
                    onClick={this.onClick}
                >
                    {positionTable === GAMER_1 && <td/>}
                    <td>{bet.suggestion ? <div className="incubator-line-table-indicator"></div> : this.timeBeforeAccepting()}</td>
                    <td>{betMoney(bet, null, false, false)}</td>
                    <td>{fixed3(bet.coef)}</td>
                    <td>{betMoneyCurrency(false, fixed2(bet.winning_money))}</td>
                    <td> {bet.suggestion && this.renderAcceptCancelButtons(bet.not_accept)}
                    </td>
                    {positionTable === GAMER_2 && <td/>}
                </tr>
                : <tr
                    className={`${bet.not_accept ? 'disable' : ''}`}
                    onClick={this.onClick}
                >
                    <td>{bet.suggestion ? <div className="incubator-line-table-indicator"></div> : this.timeBeforeAccepting()}</td>
                    <td>{betMoney(bet, null, false, false)}</td>
                    <td>{fixed3(bet.coef)}</td>
                    <td> {bet.suggestion && this.renderAcceptCancelButtons(bet.not_accept)}
                    </td>
                </tr>}
        </>;
    }
}
